export const wait = (delay: number): Promise<any> => {
  return new Promise(callback => window.setTimeout(callback, delay));
}
